// extracted by mini-css-extract-plugin
export default {"ContactInfo":"ContactInfo_ContactInfo__rXAAG","ContactIcons":"ContactInfo_ContactIcons__svZY9"};